(function () {
    'use strict';

    angular.module("imApp").factory("myPositionService", ['$ihttp', function ($ihttp) {
        let service = {
            getPosition: function (parms) {
                return $ihttp.post({
                    method: 504,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
